/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdCheckboxGroupProps, TdCheckboxProps } from './type';

export const checkboxDefaultProps: TdCheckboxProps = {
  checkAll: false,
  defaultChecked: false,
  disabled: undefined,
  indeterminate: false,
  readonly: false,
  readOnly: false,
};

export const checkboxGroupDefaultProps: TdCheckboxGroupProps = { max: undefined, defaultValue: [] };
